exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.inviteParticipants .item_container{padding:0 20px\n}\n.inviteParticipants .no_more_data_span{background-color:#fff !important\n}\n", ""]);

// exports
